define([
	"dijit/form/ToggleButton",
	"./_Plugin",
	"./PluginFactory"
], function(ToggleButton,_Plugin,PluginFactory) {

	return PluginFactory.declare([ToggleButton, _Plugin], {
		fill: false,
		"class": "csi-button-toggle",
		iconClass: "csiActionIcon svgIconCurve",
		pluginName: "curve",
		title: "CanvasCurve",
		tagShape: "path",

		/**
		 * Enable and disable the curve mode
		 * @param {Shape[]} shapes
		 * @param {Object} shapeAttrs
		 * @param {Object} textAttrs
		 * @return {boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			if (!this.editor.isDrawMode(this.pluginName) || (shapes && shapes.length)) {
				this.set('checked', false);
			}
			return true;
		},

		/**
		 * Invoke draw custom shape action
		 */
		onClick: function() {
			// Set draw mode without shape tool.
			this.editor.setDrawMode();
			this.set('checked', true);
		}
	});
});
